import { Box } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'

interface Props {
  item: any
}

export default function ICDItem({ item }: Props) {

  return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
        borderRadius="10px"
        border={`1px solid ${colors.itemBorder}`}
      >
        <Box p={0.5}>
          <CustomText text={item?.icd_lookup?.code || item?.code} color={colors.primary} />
          <CustomText text={item?.icd_lookup?.value || item?.value} color={colors.black} />
        </Box>
      </Box>
  )
}
